import api from '@/services/utils/apiInstance'

class DashboardStatisticsService {
  async getProductManufacturerActiveCounts() {
    const response = await api.get('/common/statistics/product-manufacturer/active-counts')
    return response.data
  }
}

export default new DashboardStatisticsService()
